import FieldController from '../field.controller';

class FormulaFieldController extends FieldController {
  constructor($scope, $q, $translate, $log, $timeout, RecapFormulaCalculationService) {
    "ngInject";
    super($scope, $q, $translate, $log, $timeout);
    this.RecapFormulaCalculationService = RecapFormulaCalculationService;
  }

  $onInit() {
    super.$onInit();
  }

  calculateValue() {
    const recapResponse = this.fieldResponse && this.fieldResponse.recapResponse;
    const field = this.fieldResponse && this.fieldResponse.fieldInstance && this.fieldResponse.fieldInstance.field;

    if (!recapResponse || !field || !field.formula) {
      return null;
    }

    const referencedFieldIds = this.RecapFormulaCalculationService.getFieldIdsReferencedInFormula(field.formula);
    const fieldValues = {};
    referencedFieldIds.forEach(fieldId => {
      fieldValues[fieldId] = recapResponse.collectAllVisibleFieldResponseCurrentNumericValuesMatchingFieldId(fieldId);
    });

    const result = this.RecapFormulaCalculationService.evaluate(field.formula, fieldValues);

    // Set current value on FieldResponse
    this.fieldResponse.currentValue = result;
    return result;
  }

  get calculatedValue() {
    return this.calculateValue();
  }
}

export default FormulaFieldController;

